export const snCharts = [
  {
    title: 'Percentage of Children with Outstanding MMRV 1',
    ref: 'dynamicArrayV4',
    summary_search_parameter_for_charts: 'MissingVaccine=512',
    main_link_for_chart: '/vaccine-history?MissingVaccine=512',
    filters: [
      {
        total_text: 'Total registered',
        total: 'SchoolYear=0',
        value: 'SchoolYear=0&MissingVaccine=512',
        link: '/vaccine-history?SchoolYear=0&MissingVaccine=512',
        label: 'R',
        custom_property_name_2: 'School year',
        custom_property_value_2: 'R',
        filtered_total_text: 'Outstanding MMRV 1',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=1',
        value: 'SchoolYear=1&MissingVaccine=512',
        link: '/vaccine-history?SchoolYear=1&MissingVaccine=512',
        label: 'Y1',
        custom_property_name_2: 'School year',
        custom_property_value_2: '1',
        filtered_total_text: 'Outstanding MMRV 1',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=2',
        value: 'SchoolYear=2&MissingVaccine=512',
        link: '/vaccine-history?SchoolYear=2&MissingVaccine=512',
        label: 'Y2',
        custom_property_name_2: 'School year',
        custom_property_value_2: '2',
        filtered_total_text: 'Outstanding MMRV 1',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=3',
        value: 'SchoolYear=3&MissingVaccine=512',
        link: '/vaccine-history?SchoolYear=3&MissingVaccine=512',
        label: 'Y3',
        custom_property_name_2: 'School year',
        custom_property_value_2: '3',
        filtered_total_text: 'Outstanding MMRV 1',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=4',
        value: 'SchoolYear=4&MissingVaccine=512',
        link: '/vaccine-history?SchoolYear=4&MissingVaccine=512',
        label: 'Y4',
        custom_property_name_2: 'School year',
        custom_property_value_2: '4',
        filtered_total_text: 'Outstanding MMRV 1',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=5',
        value: 'SchoolYear=5&MissingVaccine=512',
        link: '/vaccine-history?SchoolYear=5&MissingVaccine=512',
        label: 'Y5',
        custom_property_name_2: 'School year',
        custom_property_value_2: '5',
        filtered_total_text: 'Outstanding MMRV 1',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=6',
        value: 'SchoolYear=6&MissingVaccine=512',
        link: '/vaccine-history?SchoolYear=6&MissingVaccine=512',
        label: 'Y6',
        custom_property_name_2: 'School year',
        custom_property_value_2: '6',
        filtered_total_text: 'Outstanding MMRV 1',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=7',
        value: 'SchoolYear=7&MissingVaccine=512',
        link: '/vaccine-history?SchoolYear=7&MissingVaccine=512',
        label: 'Y7',
        custom_property_name_2: 'School year',
        custom_property_value_2: '7',
        filtered_total_text: 'Outstanding MMRV 1',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=8',
        value: 'SchoolYear=8&MissingVaccine=512',
        link: '/vaccine-history?SchoolYear=8&MissingVaccine=512',
        label: 'Y8',
        custom_property_name_2: 'School year',
        custom_property_value_2: '8',
        filtered_total_text: 'Outstanding MMRV 1',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=9',
        value: 'SchoolYear=9&MissingVaccine=512',
        link: '/vaccine-history?SchoolYear=9&MissingVaccine=512',
        label: 'Y9',
        custom_property_name_2: 'School year',
        custom_property_value_2: '9',
        filtered_total_text: 'Outstanding MMRV 1',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=10',
        value: 'SchoolYear=10&MissingVaccine=512',
        link: '/vaccine-history?SchoolYear=10&MissingVaccine=512',
        label: 'Y10',
        custom_property_name_2: 'School year',
        custom_property_value_2: '10',
        filtered_total_text: 'Outstanding MMRV 1',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=11',
        value: 'SchoolYear=11&MissingVaccine=512',
        link: '/vaccine-history?SchoolYear=11&MissingVaccine=512',
        label: 'Y11',
        custom_property_name_2: 'School year',
        custom_property_value_2: '11',
        filtered_total_text: 'Outstanding MMRV 1',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=12',
        value: 'SchoolYear=12&MissingVaccine=512',
        link: '/vaccine-history?SchoolYear=12&MissingVaccine=512',
        label: 'Y12',
        custom_property_name_2: 'School year',
        custom_property_value_2: '12',
        filtered_total_text: 'Outstanding MMRV 1',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=13',
        value: 'SchoolYear=13&MissingVaccine=512',
        link: '/vaccine-history?SchoolYear=13&MissingVaccine=512',
        label: 'Y13',
        custom_property_name_2: 'School year',
        custom_property_value_2: '13',
        filtered_total_text: 'Outstanding MMRV 1',
        filtered_total_value: '',
      },
    ],
  },
  {
    title: 'Percentage of Children with Outstanding MMRV 2',
    ref: 'dynamicArrayV4',
    summary_search_parameter_for_charts: 'MissingVaccine=1024',
    main_link_for_chart: '/vaccine-history?MissingVaccine=1024',
    filters: [
      {
        total_text: 'Total registered',
        total: 'SchoolYear=0',
        value: 'SchoolYear=0&MissingVaccine=1024',
        link: '/vaccine-history?SchoolYear=0&MissingVaccine=1024',
        label: 'R',
        custom_property_name_2: 'School year',
        custom_property_value_2: 'R',
        filtered_total_text: 'Outstanding MMRV 2',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=1',
        value: 'SchoolYear=1&MissingVaccine=1024',
        link: '/vaccine-history?SchoolYear=1&MissingVaccine=1024',
        label: 'Y1',
        custom_property_name_2: 'School year',
        custom_property_value_2: '1',
        filtered_total_text: 'Outstanding MMRV 2',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=2',
        value: 'SchoolYear=2&MissingVaccine=1024',
        link: '/vaccine-history?SchoolYear=2&MissingVaccine=1024',
        label: 'Y2',
        custom_property_name_2: 'School year',
        custom_property_value_2: '2',
        filtered_total_text: 'Outstanding MMRV 2',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=3',
        value: 'SchoolYear=3&MissingVaccine=1024',
        link: '/vaccine-history?SchoolYear=3&MissingVaccine=1024',
        label: 'Y3',
        custom_property_name_2: 'School year',
        custom_property_value_2: '3',
        filtered_total_text: 'Outstanding MMRV 2',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=4',
        value: 'SchoolYear=4&MissingVaccine=1024',
        link: '/vaccine-history?SchoolYear=4&MissingVaccine=1024',
        label: 'Y4',
        custom_property_name_2: 'School year',
        custom_property_value_2: '4',
        filtered_total_text: 'Outstanding MMRV 2',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=5',
        value: 'SchoolYear=5&MissingVaccine=1024',
        link: '/vaccine-history?SchoolYear=5&MissingVaccine=1024',
        label: 'Y5',
        custom_property_name_2: 'School year',
        custom_property_value_2: '5',
        filtered_total_text: 'Outstanding MMRV 2',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=6',
        value: 'SchoolYear=6&MissingVaccine=1024',
        link: '/vaccine-history?SchoolYear=6&MissingVaccine=1024',
        label: 'Y6',
        custom_property_name_2: 'School year',
        custom_property_value_2: '6',
        filtered_total_text: 'Outstanding MMRV 2',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=7',
        value: 'SchoolYear=7&MissingVaccine=1024',
        link: '/vaccine-history?SchoolYear=7&MissingVaccine=1024',
        label: 'Y7',
        custom_property_name_2: 'School year',
        custom_property_value_2: '7',
        filtered_total_text: 'Outstanding MMRV 2',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=8',
        value: 'SchoolYear=8&MissingVaccine=1024',
        link: '/vaccine-history?SchoolYear=8&MissingVaccine=1024',
        label: 'Y8',
        custom_property_name_2: 'School year',
        custom_property_value_2: '8',
        filtered_total_text: 'Outstanding MMRV 2',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=9',
        value: 'SchoolYear=9&MissingVaccine=1024',
        link: '/vaccine-history?SchoolYear=9&MissingVaccine=1024',
        label: 'Y9',
        custom_property_name_2: 'School year',
        custom_property_value_2: '9',
        filtered_total_text: 'Outstanding MMRV 2',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=10',
        value: 'SchoolYear=10&MissingVaccine=1024',
        link: '/vaccine-history?SchoolYear=10&MissingVaccine=1024',
        label: 'Y10',
        custom_property_name_2: 'School year',
        custom_property_value_2: '10',
        filtered_total_text: 'Outstanding MMRV 2',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=11',
        value: 'SchoolYear=11&MissingVaccine=1024',
        link: '/vaccine-history?SchoolYear=11&MissingVaccine=1024',
        label: 'Y11',
        custom_property_name_2: 'School year',
        custom_property_value_2: '11',
        filtered_total_text: 'Outstanding MMRV 2',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=12',
        value: 'SchoolYear=12&MissingVaccine=1024',
        link: '/vaccine-history?SchoolYear=12&MissingVaccine=1024',
        label: 'Y12',
        custom_property_name_2: 'School year',
        custom_property_value_2: '12',
        filtered_total_text: 'Outstanding MMRV 2',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=13',
        value: 'SchoolYear=13&MissingVaccine=1024',
        link: '/vaccine-history?SchoolYear=13&MissingVaccine=1024',
        label: 'Y13',
        custom_property_name_2: 'School year',
        custom_property_value_2: '13',
        filtered_total_text: 'Outstanding MMRV 2',
        filtered_total_value: '',
      },
    ],
  },
  {
    title: 'Percentage of Children with Outstanding HPV 1',
    ref: 'dynamicArrayV4',
    summary_search_parameter_for_charts: 'MissingVaccine=32',
    main_link_for_chart: '/vaccine-history?MissingVaccine=32',
    filters: [
      {
        total_text: 'Total registered',
        total: 'SchoolYear=8',
        value: 'SchoolYear=8&MissingVaccine=32',
        link: '/vaccine-history?SchoolYear=8&MissingVaccine=32',
        label: 'Y8',
        custom_property_name_2: 'School year',
        custom_property_value_2: '8',
        filtered_total_text: 'Outstanding HPV 1',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=9',
        value: 'SchoolYear=9&MissingVaccine=32',
        link: '/vaccine-history?SchoolYear=9&MissingVaccine=32',
        label: 'Y9',
        custom_property_name_2: 'School year',
        custom_property_value_2: '9',
        filtered_total_text: 'Outstanding HPV 1',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=10',
        value: 'SchoolYear=10&MissingVaccine=32',
        link: '/vaccine-history?SchoolYear=10&MissingVaccine=32',
        label: 'Y10',
        custom_property_name_2: 'School year',
        custom_property_value_2: '10',
        filtered_total_text: 'Outstanding HPV 1',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=11',
        value: 'SchoolYear=11&MissingVaccine=32',
        link: '/vaccine-history?SchoolYear=11&MissingVaccine=32',
        label: 'Y11',
        custom_property_name_2: 'School year',
        custom_property_value_2: '11',
        filtered_total_text: 'Outstanding HPV 1',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=12',
        value: 'SchoolYear=12&MissingVaccine=32',
        link: '/vaccine-history?SchoolYear=12&MissingVaccine=32',
        label: 'Y12',
        custom_property_name_2: 'School year',
        custom_property_value_2: '12',
        filtered_total_text: 'Outstanding HPV 1',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=13',
        value: 'SchoolYear=13&MissingVaccine=32',
        link: '/vaccine-history?SchoolYear=13&MissingVaccine=32',
        label: 'Y13',
        custom_property_name_2: 'School year',
        custom_property_value_2: '13',
        filtered_total_text: 'Outstanding HPV 1',
        filtered_total_value: '',
      },
    ],
  },
  {
    title: 'Percentage of Children with Outstanding Td/IPV',
    ref: 'dynamicArrayV4',
    summary_search_parameter_for_charts: 'MissingVaccine=4',
    main_link_for_chart: '/vaccine-history?MissingVaccine=4',
    filters: [
      {
        total_text: 'Total registered',
        total: 'SchoolYear=9',
        value: 'SchoolYear=9&MissingVaccine=4',
        link: '/vaccine-history?SchoolYear=9&MissingVaccine=4',
        label: 'Y9',
        custom_property_name_2: 'School year',
        custom_property_value_2: '9',
        filtered_total_text: 'Outstanding Td/IPV',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=10',
        value: 'SchoolYear=10&MissingVaccine=4',
        link: '/vaccine-history?SchoolYear=10&MissingVaccine=4',
        label: 'Y10',
        custom_property_name_2: 'School year',
        custom_property_value_2: '10',
        filtered_total_text: 'Outstanding Td/IPV',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=11',
        value: 'SchoolYear=11&MissingVaccine=4',
        link: '/vaccine-history?SchoolYear=11&MissingVaccine=4',
        label: 'Y11',
        custom_property_name_2: 'School year',
        custom_property_value_2: '11',
        filtered_total_text: 'Outstanding Td/IPV',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=12',
        value: 'SchoolYear=12&MissingVaccine=4',
        link: '/vaccine-history?SchoolYear=12&MissingVaccine=4',
        label: 'Y12',
        custom_property_name_2: 'School year',
        custom_property_value_2: '12',
        filtered_total_text: 'Outstanding Td/IPV',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=13',
        value: 'SchoolYear=13&MissingVaccine=4',
        link: '/vaccine-history?SchoolYear=13&MissingVaccine=4',
        label: 'Y13',
        custom_property_name_2: 'School year',
        custom_property_value_2: '13',
        filtered_total_text: 'Outstanding Td/IPV',
        filtered_total_value: '',
      },
    ],
  },
  {
    title: 'Percentage of Children with Outstanding MenACWY',
    ref: 'dynamicArrayV4',
    summary_search_parameter_for_charts: 'MissingVaccine=32',
    main_link_for_chart: '/vaccine-history?MissingVaccine=32',
    filters: [
      {
        total_text: 'Total registered',
        total: 'SchoolYear=9',
        value: 'SchoolYear=9&MissingVaccine=32',
        link: '/vaccine-history?SchoolYear=9&MissingVaccine=32',
        label: 'Y9',
        custom_property_name_2: 'School year',
        custom_property_value_2: '9',
        filtered_total_text: 'Outstanding MenACWY',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=10',
        value: 'SchoolYear=10&MissingVaccine=32',
        link: '/vaccine-history?SchoolYear=10&MissingVaccine=32',
        label: 'Y10',
        custom_property_name_2: 'School year',
        custom_property_value_2: '10',
        filtered_total_text: 'Outstanding MenACWY',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=11',
        value: 'SchoolYear=11&MissingVaccine=32',
        link: '/vaccine-history?SchoolYear=11&MissingVaccine=32',
        label: 'Y11',
        custom_property_name_2: 'School year',
        custom_property_value_2: '11',
        filtered_total_text: 'Outstanding MenACWY',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=12',
        value: 'SchoolYear=12&MissingVaccine=32',
        link: '/vaccine-history?SchoolYear=12&MissingVaccine=32',
        label: 'Y12',
        custom_property_name_2: 'School year',
        custom_property_value_2: '12',
        filtered_total_text: 'Outstanding MenACWY',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=13',
        value: 'SchoolYear=13&MissingVaccine=32',
        link: '/vaccine-history?SchoolYear=13&MissingVaccine=32',
        label: 'Y13',
        custom_property_name_2: 'School year',
        custom_property_value_2: '13',
        filtered_total_text: 'Outstanding MenACWY',
        filtered_total_value: '',
      },
    ],
  },
  {
    title: 'Percentage of Children with Refusals',
    ref: 'dynamicArrayV4',
    summary_search_parameter_for_charts: 'HasRefusals=true',
    main_link_for_chart: '/vaccine-history?HasRefusals=true',
    filters: [
      {
        total_text: 'Total registered',
        total: 'SchoolYear=0',
        value: 'HasRefusals=true',
        link: '/vaccine-history?HasRefusals=true&SchoolYear=0',
        label: 'R',
        custom_property_name_2: 'School year',
        custom_property_value_2: 'R',
        filtered_total_text: 'Children with Refusals',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=1',
        value: 'HasRefusals=true',
        link: '/vaccine-history?HasRefusals=true&SchoolYear=1',
        label: 'Y1',
        custom_property_name_2: 'School year',
        custom_property_value_2: '1',
        filtered_total_text: 'Children with Refusals',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=2',
        value: 'HasRefusals=true',
        link: '/vaccine-history?HasRefusals=true&SchoolYear=2',
        label: 'Y2',
        custom_property_name_2: 'School year',
        custom_property_value_2: '2',
        filtered_total_text: 'Children with Refusals',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=3',
        value: 'HasRefusals=true',
        link: '/vaccine-history?HasRefusals=true&SchoolYear=3',
        label: 'Y3',
        custom_property_name_2: 'School year',
        custom_property_value_2: '3',
        filtered_total_text: 'Children with Refusals',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=4',
        value: 'HasRefusals=true',
        link: '/vaccine-history?HasRefusals=true&SchoolYear=4',
        label: 'Y4',
        custom_property_name_2: 'School year',
        custom_property_value_2: '4',
        filtered_total_text: 'Children with Refusals',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=5',
        value: 'HasRefusals=true',
        link: '/vaccine-history?HasRefusals=true&SchoolYear=5',
        label: 'Y5',
        custom_property_name_2: 'School year',
        custom_property_value_2: '5',
        filtered_total_text: 'Children with Refusals',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=6',
        value: 'HasRefusals=true',
        link: '/vaccine-history?HasRefusals=true&SchoolYear=6',
        label: 'Y6',
        custom_property_name_2: 'School year',
        custom_property_value_2: '6',
        filtered_total_text: 'Children with Refusals',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=7',
        value: 'HasRefusals=true',
        link: '/vaccine-history?HasRefusals=true&SchoolYear=7',
        label: 'Y7',
        custom_property_name_2: 'School year',
        custom_property_value_2: '7',
        filtered_total_text: 'Children with Refusals',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=8',
        value: 'HasRefusals=true',
        link: '/vaccine-history?HasRefusals=true&SchoolYear=8',
        label: 'Y8',
        custom_property_name_2: 'School year',
        custom_property_value_2: '8',
        filtered_total_text: 'Children with Refusals',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=9',
        value: 'HasRefusals=true',
        link: '/vaccine-history?HasRefusals=true&SchoolYear=9',
        label: 'Y9',
        custom_property_name_2: 'School year',
        custom_property_value_2: '9',
        filtered_total_text: 'Children with Refusals',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=10',
        value: 'HasRefusals=true',
        link: '/vaccine-history?HasRefusals=true&SchoolYear=10',
        label: 'Y10',
        custom_property_name_2: 'School year',
        custom_property_value_2: '10',
        filtered_total_text: 'Children with Refusals',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=11',
        value: 'HasRefusals=true',
        link: '/vaccine-history?HasRefusals=true&SchoolYear=11',
        label: 'Y11',
        custom_property_name_2: 'School year',
        custom_property_value_2: '11',
        filtered_total_text: 'Children with Refusals',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=12',
        value: 'HasRefusals=true',
        link: '/vaccine-history?HasRefusals=true&SchoolYear=12',
        label: 'Y12',
        custom_property_name_2: 'School year',
        custom_property_value_2: '12',
        filtered_total_text: 'Children with Refusals',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=13',
        value: 'HasRefusals=true',
        link: '/vaccine-history?HasRefusals=true&SchoolYear=13',
        label: 'Y13',
        custom_property_name_2: 'School year',
        custom_property_value_2: '13',
        filtered_total_text: 'Children with Refusals',
        filtered_total_value: '',
      },
    ],
  },
  {
    title: 'Percentage of Children with Suspensions',
    ref: 'dynamicArrayV4',
    summary_search_parameter_for_charts: 'HasSuspensions=true',
    main_link_for_chart: '/vaccine-history?HasSuspensions=true',
    filters: [
      {
        total_text: 'Total registered',
        total: 'SchoolYear=0',
        value: 'HasSuspensions=true',
        link: '/vaccine-history?HasSuspensions=true&SchoolYear=0',
        label: 'R',
        custom_property_name_2: 'School year',
        custom_property_value_2: 'R',
        filtered_total_text: 'Children with Suspensions',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=1',
        value: 'HasSuspensions=true',
        link: '/vaccine-history?HasSuspensions=true&SchoolYear=1',
        label: 'Y1',
        custom_property_name_2: 'School year',
        custom_property_value_2: '1',
        filtered_total_text: 'Children with Suspensions',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=2',
        value: 'HasSuspensions=true',
        link: '/vaccine-history?HasSuspensions=true&SchoolYear=2',
        label: 'Y2',
        custom_property_name_2: 'School year',
        custom_property_value_2: '2',
        filtered_total_text: 'Children with Suspensions',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=3',
        value: 'HasSuspensions=true',
        link: '/vaccine-history?HasSuspensions=true&SchoolYear=3',
        label: 'Y3',
        custom_property_name_2: 'School year',
        custom_property_value_2: '3',
        filtered_total_text: 'Children with Suspensions',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=4',
        value: 'HasSuspensions=true',
        link: '/vaccine-history?HasSuspensions=true&SchoolYear=4',
        label: 'Y4',
        custom_property_name_2: 'School year',
        custom_property_value_2: '4',
        filtered_total_text: 'Children with Suspensions',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=5',
        value: 'HasSuspensions=true',
        link: '/vaccine-history?HasSuspensions=true&SchoolYear=5',
        label: 'Y5',
        custom_property_name_2: 'School year',
        custom_property_value_2: '5',
        filtered_total_text: 'Children with Suspensions',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=6',
        value: 'HasSuspensions=true',
        link: '/vaccine-history?HasSuspensions=true&SchoolYear=6',
        label: 'Y6',
        custom_property_name_2: 'School year',
        custom_property_value_2: '6',
        filtered_total_text: 'Children with Suspensions',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=7',
        value: 'HasSuspensions=true',
        link: '/vaccine-history?HasSuspensions=true&SchoolYear=7',
        label: 'Y7',
        custom_property_name_2: 'School year',
        custom_property_value_2: '7',
        filtered_total_text: 'Children with Suspensions',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=8',
        value: 'HasSuspensions=true',
        link: '/vaccine-history?HasSuspensions=true&SchoolYear=8',
        label: 'Y8',
        custom_property_name_2: 'School year',
        custom_property_value_2: '8',
        filtered_total_text: 'Children with Suspensions',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=9',
        value: 'HasSuspensions=true',
        link: '/vaccine-history?HasSuspensions=true&SchoolYear=9',
        label: 'Y9',
        custom_property_name_2: 'School year',
        custom_property_value_2: '9',
        filtered_total_text: 'Children with Suspensions',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=10',
        value: 'HasSuspensions=true',
        link: '/vaccine-history?HasSuspensions=true&SchoolYear=10',
        label: 'Y10',
        custom_property_name_2: 'School year',
        custom_property_value_2: '10',
        filtered_total_text: 'Children with Suspensions',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=11',
        value: 'HasSuspensions=true',
        link: '/vaccine-history?HasSuspensions=true&SchoolYear=11',
        label: 'Y11',
        custom_property_name_2: 'School year',
        custom_property_value_2: '11',
        filtered_total_text: 'Children with Suspensions',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=12',
        value: 'HasSuspensions=true',
        link: '/vaccine-history?HasSuspensions=true&SchoolYear=12',
        label: 'Y12',
        custom_property_name_2: 'School year',
        custom_property_value_2: '12',
        filtered_total_text: 'Children with Suspensions',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'SchoolYear=13',
        value: 'HasSuspensions=true',
        link: '/vaccine-history?HasSuspensions=true&SchoolYear=13',
        label: 'Y13',
        custom_property_name_2: 'School year',
        custom_property_value_2: '13',
        filtered_total_text: 'Children with Suspensions',
        filtered_total_value: '',
      },
    ],
  },
];
